import { render, staticRenderFns } from "./TempProductPage.vue?vue&type=template&id=b0623ab2&"
import script from "./TempProductPage.vue?vue&type=script&lang=js&"
export * from "./TempProductPage.vue?vue&type=script&lang=js&"
import style0 from "./TempProductPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports